<app-dialog-page>
    <app-login-entry
        [error]="error"
        [urlUserId]="urlUserId"
        (loginEvent)="login($event)"
    ></app-login-entry>
</app-dialog-page>
